import {
  AppointmentSvg,
  FinancesSvg,
  LogoSvg,
  PatientsSvg,
} from 'icons'
import React, { useEffect, useState } from 'react'
import { matchPath, useLocation } from 'react-router'

import AvatarPNG from 'components/Header/Avatar.png'
import Container from 'components/Container'
import Divider from 'components/Divider'
import Header from 'components/Header'
import Sidebar from 'components/Sidebar'
import SidebarLayout from 'components/SidebarLayout'
import { classNames } from 'helpers'
import config from 'config/main'
import { setLanguage } from 'config/languageSelector'
import TeleConsultSvg from 'icons/TeleConsultSvg'
import HAYFTSvg from 'icons/HAYFTSvg'

const routeData = config.pageData

function Main({ children }) {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const componentData = config.staticData.componentData
  const pageData = config.staticData.pageData

  const [currentPath, setCurrentPath] = React.useState(
    routeData.Appointments.route.path
  )

  useEffect(() => {
    setCurrentPath(location.pathname)
  }, [location.pathname])

  const isRouteSelected = (route) => {
    return route === currentPath
  }

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage)
    window.location.reload()
  }


  const data = {
    languages: [
      {
        name: 'English',
        onClick: () => {
          changeLanguage('en')
        },
      },
      {
        name: 'Spanish',
        onClick: () => {
          changeLanguage('es')
        },
      },
    ],
    sidebarNavigation: [
      {
        name: componentData.sideBar.tab1,
        href: routeData.Appointments.route.path,
        icon: AppointmentSvg,
        current: isRouteSelected(
          routeData.Appointments.route.path
        ),
      },
      {
        name: componentData.sideBar.tab2,
        href: routeData.Patients.route.path,
        icon: PatientsSvg,
        current: isRouteSelected(routeData.Patients.route.path),
      },
      {
        name: componentData.sideBar.tab3,
        href: routeData.Finances.route.path,
        icon: FinancesSvg,
        current: isRouteSelected(routeData.Finances.route.path),
      },
      {
        name: componentData.sideBar.tab4,
        href: routeData.TeleConsult.route.path,
        icon: TeleConsultSvg,
        current: isRouteSelected(routeData.TeleConsult.route.path),
      },
      {
        name: componentData.sideBar.tab5,
        href: routeData.HAYFT.route.path,
        icon: HAYFTSvg,
        current: isRouteSelected(routeData.HAYFT.route.path),
      },
    ],
    navigation: [
      {
        name: componentData.sideBar.tab1,
        href: routeData.Appointments.route.path,
        icon: AppointmentSvg,
        current: isRouteSelected(
          routeData.Appointments.route.path
        ),
      },
      {
        name: componentData.sideBar.tab2,
        href: routeData.Patients.route.path,
        icon: PatientsSvg,
        current: isRouteSelected(routeData.Patients.route.path),
      },
      {
        name: componentData.sideBar.tab3,
        href: routeData.Finances.route.path,
        icon: FinancesSvg,
        current: isRouteSelected(routeData.Finances.route.path),
      },
      {
        name: componentData.sideBar.tab4,
        href: routeData.TeleConsult.route.path,
        icon: TeleConsultSvg,
        current: isRouteSelected(routeData.TeleConsult.route.path),
      },
      {
        name: componentData.sideBar.tab5,
        href: routeData.HAYFT.route.path,
        icon: HAYFTSvg,
        current: isRouteSelected(routeData.HAYFT.route.path),
      },
    ],
  }

  const { languages, sidebarNavigation, navigation } = data

  if (
    location.pathname === '/' ||
    location.pathname === '/login' ||
    location.pathname === '/register' ||
    location.pathname === '/forgot-password' ||
    location.pathname === '/welcome'
  ) {
    return (
      <div className="min-h-screen bg-white">
        <Container>
          {children}
        </Container>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-blue-0">
      <Container>
        <Header
          logo={LogoSvg}
          action={componentData.header.action}
          image={AvatarPNG}
          name={componentData.header.name}
          date="Monday | 31 August"
          languages={languages}
          setSidebarOpen={setSidebarOpen}
          className="md:pr-21"
        />
        <Divider />
        <div className="md:pr-21">
          {
            location.pathname === '/settings' ? (
              <div className="min-h-screen md:ml-24">
                {children}
              </div>
            ) : (
              <SidebarLayout
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                sidebarNavigation={sidebarNavigation}
                navigation={navigation}
              >
                {children}
              </SidebarLayout>
            )
          }
        </div>
      </Container>
    </div>
  )
}

export default Main
